module.exports = __webpack_public_path__ + "static/media/FrameRed.255218e8.png";